import {
  GET_OFFERS,
  GET_OFFER_BY_ID,
  DELETE_OFFER,
  EDIT_OFFER,
  SET_OFFER_TO_NULL,
  GET_YEARS,
  GET_OFFER_BY_OFFERNUMBER,
} from "./types";

const initialState = {
  offers: [],
  offerToEdit: null,
  years: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_OFFERS:
      return {
        ...state,
        offers: action.payload,
      };
    case GET_OFFER_BY_ID:
      return {
        ...state,
        offerToEdit: action.payload,
      };
    case SET_OFFER_TO_NULL:
      return {
        ...state,
        offerToEdit: null,
      };

    case GET_YEARS:
      return {
        ...state,
        years: action.payload,
      };
    case GET_OFFER_BY_OFFERNUMBER:
      return {
        ...state,
        offerToEdit: action.payload,
      };

    default:
      return state;
  }
};
